<template>
  <div class="info-row__copy" v-on:click="copy">
    <v-tooltip top
               v-if="tooltipOn"
               v-model="isCopyTooltipOn"
               content-class="details-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <div class="info-row_text-value"
             v-bind="attrs"
             v-on="on">
          <v-icon v-if="!copySuccess">icon-Copy</v-icon>
          <v-icon class="info-row__copy--success" v-if="copySuccess">icon-Completed</v-icon>
        </div>
      </template>
      <span>{{copySuccess ? tooltipCopied : tooltipCopy}}</span>
    </v-tooltip>
    <div v-else>
      <v-icon class="info-row__copy--success" v-if="copySuccess">icon-Completed</v-icon>
      <v-icon v-else>icon-Copy</v-icon>
    </div>
  </div>
</template>

<script>
import {copyToClipboard} from "@/modules/common/utils";
import {mapGetters} from "vuex";

export default {
  name: "CopyBtn",
  props: {
    copyText: {
      type: [Number, String],
      required: true,
    },
    tooltipOn: {
      type: Boolean,
      default: true
    },
    tooltipCopy: {
      type: String
    },
    tooltipCopied: {
      type: String
    },
  },
  data() {
    return {
      copySuccess: false,
      isCopyTooltipOn: false
    }
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  methods: {
    setIsCopyTooltipOn() {
      if(this.isMobile) {
        this.isCopyTooltipOn = this.copySuccess
      }
    },
    copy() {
      copyToClipboard.copy(this.copyText);
      this.copySuccess = true;
      this.setIsCopyTooltipOn();
      setTimeout(() => {
        this.copySuccess = false;
        this.setIsCopyTooltipOn()
      }, 3000);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.info-row__copy {
  z-index: 49;
  margin-block-start: 5px;
  width: 22px;

  i {
    font-size: 16px;
  }

  &--success {
    color: $green-color-2;
  }
}
</style>
